export default {
  en: {
    commits: {
      number: 'Commits',
      branch: 'Commits to',
      excluding: 'Excluding merge commits.',
      limit: 'Limited to {0} commits.',
      text: 'Commits: {0}'
    },
    contributors: {
      analytics: 'Repository analytics'
    }
  },
  ru: {
    commits: {
      number: 'Количество коммитов',
      branch: 'Коммиты в ветку',
      excluding: 'Без учета коммитов-результатов слияния веток.',
      limit: 'Ограничение {0} коммитов.',
      text: 'Коммитов: {0}'
    },
    contributors: {
      analytics: 'Аналитика репозитория'
    }
  }
};
